import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, inputTextColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P242List({ dataTable, setheadlerInpusText, setDis, setActionDetail }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);

    const header = (
        <div className="table-header">
            <span></span>
            <Button className="p-button-primary p-button btn-hidden-responsive span-responsive" label="รายละเอียดคะแนนการประเมิน" onClick={() => setActionDetail()} autoFocus disabled={setDis()} />
        </div>
    );

    const normalColumnCustom = (rowData, checkColumn, titleShow) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {datavalue && datavalue !== "" && datavalue !== "null" ? (datavalue === 999 ? "" : datavalue) : "-"}
            </React.Fragment>
        );
    };

    const _normalColumn = (rowData, checkColumn, titleShow) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {datavalue && datavalue !== "" && datavalue !== "null" ? (datavalue === "999" ? "" : datavalue) : ""}
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    header={header}
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="criteriaNo" header="ข้อ" body={(e) => normalColumnCustom(e, "criteriaNo", "ข้อ")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaDesc" header="หัวข้อพิจารณา" body={(e) => normalColumn(e, "criteriaDesc", "หัวข้อพิจารณา")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaWeight" header="น้ำหนัก" body={(e) => normalColumn(e, "criteriaWeight", "น้ำหนัก")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaScore" header="คะแนนที่ได้" body={(e) => _normalColumn(e, "criteriaScore", "คะแนนที่ได้")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="criteriaRemark" header="หมายเหตุ" body={(e) => inputTextColumn(e, "criteriaRemark", dataTable, setheadlerInpusText, "หมายเหตุ", "หมายเหตุ", "criteriaRemark", false, "200")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
